import React from "react";

import { useTranslation } from "react-i18next";

import { DefaultTooltip } from "../../../../../../components/Generic/Tooltip";
import GpsIcon from "../GpsIcon";
import { TrackBadge, TrackContainer } from "./styles";

interface Props {
  container?: string;
  marineTrafficId?: string;
  isEmptyState?: boolean;
  onTrackClick?: () => void;
}

const RenderContainer = (props: Props) => {
  const { t: translate } = useTranslation();
  const { marineTrafficId, container, isEmptyState, onTrackClick } = props;

  return (
    <TrackContainer>
      <span>{container || ""}</span>
      {!!container && !!marineTrafficId && !isEmptyState && (
        <DefaultTooltip title={translate("trackable")} placement="right">
          <TrackBadge onClick={() => onTrackClick?.()} showCursorOnHover={!!onTrackClick}>
            <GpsIcon color="#3377B6" size={16} />
          </TrackBadge>
        </DefaultTooltip>
      )}
    </TrackContainer>
  );
};

export default RenderContainer;
